<template>
  <popup
      ref="popup"
      :is-confirm="true"
  >
    <template #title v-if="title">
      <button v-if="btn_close" class="btnClose" @click="close(false)"/>
      <div class="modal-title WBkeepAll">
        <!-- {{title}} -->
        <span v-html="title"></span>
      </div>
    </template>

    <template #content>
      <div style="text-align:center"><div><slot></slot></div></div>
    </template>

    <template #button v-if="show_btn">
      <template v-if="btn_cancel">
        <template v-if="btn_submit">
          <span><a @click="close(false)">{{btn_cancel_title}}</a></span>
          <span><a @click="close(true)" class="fCol1">{{btn_submit_title}}</a></span>
        </template>
        <a v-else @click="close(false)">{{btn_cancel_title}}</a>
      </template>

      <template v-else>
        <a v-if="btn_submit" @click="close(true)" class="fCol1">{{btn_submit_title}}</a>
      </template>
    </template>
  </popup>
</template>
<script>
import Popup from './Popup.vue';
export default {

  components: {
    Popup,
  },

  props: {
    title: { type: String },
    show_btn: {type: Boolean, default: true},
    btn_cancel: {type: Boolean, default: false},
    btn_cancel_title: {type: String, default: '취소'},
    btn_close: {type: Boolean, default: false},
    btn_submit: {type: Boolean, default: true},
    btn_submit_title : {type: String, default: '확인'},
    onClose: Function,
  },

  methods:{
    close(isOk){
      this.$emit('close', isOk);
    },
  },
}
</script>

<style lang="css" scoped></style>